import type { FCWithChildren } from '@pbk-web/types';
import type { LucideIcon } from 'lucide-react';
import { MoreVertical } from 'lucide-react';

import { keepSelection, toolbarButtonClasses, toolbarIconClasses } from './styles';

export type ToolbarButtonProps = {
  icon: LucideIcon;
  label: string;
  active?: boolean;
  disabled?: boolean;
  /** Renders the "⋮" affordance Froala puts on its `more*` buttons. */
  more?: boolean;
  onClick: () => void;
};

export const ToolbarButton = ({ icon: Icon, label, active = false, disabled = false, more = false, onClick }: ToolbarButtonProps) => (
  <button
    type="button"
    title={label}
    aria-label={label}
    aria-pressed={active}
    disabled={disabled}
    className={toolbarButtonClasses(active, disabled)}
    onMouseDown={keepSelection}
    onClick={() => !disabled && onClick()}
  >
    <Icon className={toolbarIconClasses} strokeWidth={1.75} aria-hidden />
    {more && <MoreVertical className="-ml-0.5 size-3" strokeWidth={2} aria-hidden />}
  </button>
);

/** Froala spaces its `fr-btn-grp`s apart; separators keep the groups legible. */
export const ToolbarGroup: FCWithChildren = ({ children }) => (
  <div className="mx-1.5 flex items-center gap-0.5 group-data-[size=s]/toolbar:mx-1">{children}</div>
);

export const ToolbarSeparator = () => <span className="bg-greyscale-15 h-5 w-px" aria-hidden />;
